<template>
    <b-row>
        <b-col cols="12" class="p-0">
            <section class="content">
                <div class="container-fluid">
                    <div class="card card-primary card-outline card-outline-tabs">
                        <div class="card-header p-0 border-bottom-0">
                            <ul class="nav nav-tabs" id="custom-tabs-five-tab" role="tablist">
                                <li v-for="(tab, index) in tabs" :key="index" class="nav-item">
                                    <a :class="show === tab.tab ? 'nav-link active' : 'nav-link'" href="#" @click.prevent="show = tab.tab">
                                        {{ tab.nombre }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="card-body">
                            <div class="tab-content">
                                <div class="tab-pane fade active show">
                                    <transition name="fade" mode="out-in">
                                        <div :key="show">
                                            <slot :name="show"></slot>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        props: {
            tabs: Array,
            initialTab: String,
            title: String
        },
        data() {
            return {
                show: this.initialTab
            }
        },
        watch: {
            show(newValue) {
                this.$emit('selectTab', newValue);
            }
        }
    }
</script>

<style scoped>
@media (max-width: 700px) {
    .nav-link {
        background-color: #dee2e6;
        margin: 3px;
        border-radius: 5px;
    }

    .nav-tabs .nav-link:focus {
        border-color: lightgray lightgray white lightgray;
        border-width: 1px;
    }

    .nav-tabs .nav-link:hover {
        border-color: lightgray lightgray;
        border-width: 5px 1px 1px 1px;
    }
}
</style>